import { Resolve, Router } from '@angular/router';
import { RequestType } from '../constants/app.constant';
import { BaseDataModel, ComponentData, ResponseType, RouteMessage } from '../models/utilitymodels/base.model';
import { BaseWidgetService } from 'common/services/core_services/base.widget.service';

export abstract class BaseResolver<T extends BaseDataModel> implements Resolve<any> {
    constructor(public pageService: BaseWidgetService<T>, protected router: Router) { }

    resolve(): Promise<any> {
        return new Promise((resolve, reject) => {
            Promise.resolve()
                .then(() => {
                    return Promise.resolve(
                        // @ts-ignore
                        this.getResolverMessage(this.router.getCurrentNavigation()?.extras.state)
                    );
                })
                .then((message) => {
                    return message.type === RequestType.BACK ? this.patchBackActionData(message) : this.getDataBaseOnMessage(message);
                })
                .then((res) => {
                    if (res.hasOwnProperty('routeData') && res.routeData?.type !== RequestType.BACK) {
                        const meta = this.getMetaForComponent();
                        return this.prepareResolveData(res.dataOnMessage, meta, res.routeData);
                    } else {
                        return res;
                    }
                })
                .then((finalResult) => {
                    resolve(finalResult);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getDataBaseOnMessage(message: RouteMessage): Promise<any> {
        return new Promise((resolve, reject) => {
            let promise;
            switch (message.type) {
                case RequestType.ID:
                    promise = this.pageService.getDataById([message]);
                    break;
                case RequestType.BLANK:
                    promise = Promise.resolve(this.pageService.getDataModel());
                    break;
                case RequestType.GET:
                    promise = this.pageService.getListDataModel([message]);
                    break;
            }
            Promise.all([promise])
                .then((res) => {
                    resolve({
                        dataOnMessage: res[0],
                        routeData: message.transferData,
                    });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    patchBackActionData(message: RouteMessage) {
        return new Promise<ResponseType<T>>((resolve, reject) => {
            const responseType = new ResponseType<T>();
            responseType.data = message.transferData.pageData;
            responseType.meta = message.transferData.pageMeta;
            responseType.componentData = new ComponentData();
            responseType.componentData = message.transferData.componentData;
            responseType.componentData.actionType = message.type;
            resolve(responseType);
        });
    }

    createQueryParams(paramsData: any): any {
        return paramsData;
    }

    getMetaForComponent() {
        return this.pageService.getMetaModel();
    }

    getComponentData(): ComponentData {
        return new ComponentData();
    }

    initComponentData(): any {
        const data = this.getComponentData();
        return data;
    }

    prepareResolveData(data: any, meta: any, routeData: any): Promise<ResponseType<T>> {
        return new Promise<ResponseType<T>>((resolve, reject) => {
            this.pageService
                .prepareMetaModel(data, meta, routeData)
                .then((modifiedMeta) => {
                    const responseType = new ResponseType<T>();
                    responseType.data = data;
                    responseType.meta = modifiedMeta;
                    responseType.componentData = this.initComponentData();
                    responseType.componentData.isFormRender = meta.isFormRender;
                    responseType.componentData.routeData = routeData;
                    resolve(responseType);
                })
                .catch((err: any) => {
                    reject(err);
                });
        });
    }

    getResolverMessage(message: RouteMessage) {
        if (!message) {
            const routeMsg = new RouteMessage();
            routeMsg.type = RequestType.BLANK;
            routeMsg.transferData = null;
            this.router.navigate([''], { state: routeMsg, replaceUrl: true });
        }
        return message;
    }

    modifyMeta(metaModel: any, dataModel: any) {
        return metaModel;
    }
}
